export default "__VITE_ASSET__b7f2940e__"